import * as helper from './../../../../../VX/View/Assets/Js/helper';

export function initPeople(element: HTMLDivElement) {
	const slider:HTMLDivElement = element.querySelector('.float');
	let currentPos = 0;
	let targetPos = 0;
	let autoScroll = -1;

	let downStart = 0;

	function animate() {
		targetPos += autoScroll;

		const direction = element.getBoundingClientRect().width < element.getBoundingClientRect().height ? 'vertical' : 'horizontal';

		if (targetPos > 0) {
			targetPos = 0;
			autoScroll *= -1;
		}

		let maxPos;

		if (direction === 'vertical') {
			maxPos = -1 * slider.getBoundingClientRect().height + element.getBoundingClientRect().height;
		} else {
			maxPos = -1 * slider.getBoundingClientRect().width + element.getBoundingClientRect().width;
		}

		if (targetPos < maxPos && maxPos !== 0) {
			targetPos = maxPos;
			autoScroll *= -1;
		}

		if (currentPos !== targetPos) {
			let distance = (currentPos - targetPos) / 10;

			currentPos = currentPos - distance + autoScroll;

			if (direction === 'horizontal') {
				slider.style.transform = `translateX(${currentPos}px)`;
			} else {
				slider.style.transform = `translateY(${currentPos}px)`;
			}
		}

		window.requestAnimationFrame(animate);
	}

	window.requestAnimationFrame(animate);

	helper.addEventListener(element, 'touchstart', (e: TouchEvent) => {
		downStart = e.touches.item(0).clientX;
		autoScroll = 0;
	})
	helper.addEventListener(element, 'touchend', (e: TouchEvent) => {
		const distance = (e.changedTouches.item(0).clientX - downStart) * 3;
		targetPos += distance;
	})
}
